import { render } from "./PaymentGatewayComponent.vue?vue&type=template&id=2cfc7c02"
import script from "./PaymentGatewayComponent.vue?vue&type=script&lang=js"
export * from "./PaymentGatewayComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/PaymentGateway/PaymentGatewayComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cfc7c02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cfc7c02', __exports__)) {
    api.reload('2cfc7c02', __exports__)
  }
  
  module.hot.accept("./PaymentGatewayComponent.vue?vue&type=template&id=2cfc7c02", () => {
    api.rerender('2cfc7c02', render)
  })

}


export default __exports__